import Icon from 'chameleon/ui-stack/ui/base/icon';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import { isSmithsonianResource } from 'chameleon/ui-stack/ui/units/subunit-content/SourceResources';
import JstorLink from 'chameleon/ui-stack/ui/units/subunit-content/JstorLink';
import { isResourceWithJstorLink } from 'chameleon/ui-stack/ui/units/utils/Utils';
import ResourceTypes from 'legacy-packages/unit-outline/src/constants';
import LTILink from 'chameleon/ui-stack/ui/units/subunit-content/LTILink';
import { ICON_IDS } from '../../utils/constants';
import PropTypes from 'prop-types';
import React from 'react';

const Description = ({ resource, count, onNameClick }) => {
  const {
    id: resourceId,
    url,
    __typename: type,
    displayName,
    description,
  } = resource;

  const linkContent = (
    <>
      {displayName} {count > 0 && <span>({count})</span>}
      {isSmithsonianResource(displayName) && (
        <Icon name="smithsonian" className="align-middle ml-4" />
      )}
    </>
  );

  const className =
    'font-medium text-black leading-8.2 hover:underline cursor-pointer';

  let link;

  if (isResourceWithJstorLink(url)) {
    link = (
      <JstorLink className={className} resource={resource}>
        {linkContent}
      </JstorLink>
    );
  } else if (type === ResourceTypes.LTI) {
    link = (
      <LTILink
        resourceId={resourceId}
        url={url}
        aria-label={displayName}
        className={className}
      >
        {linkContent}
      </LTILink>
    );
  } else {
    link = (
      <A11y>
        <div
          className={className}
          role="button"
          tabIndex={0}
          onClick={onNameClick}
        >
          {linkContent}
        </div>
      </A11y>
    );
  }

  return (
    <div className="flex mr-4.6">
      <div className="flex mr-0.8">
        <Icon id={ICON_IDS[type] || 'play_circle'} width="36" height="36" />
      </div>
      <div>
        {link}
        <div className="text-gray-700 text-14 font-normal mt-0.8 leading-8.2">
          {description}
        </div>
      </div>
    </div>
  );
};

Description.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  onNameClick: PropTypes.func,
};

Description.defaultProps = {
  onNameClick: () => {},
};

export default Description;
